import script from "./jivo-chat-widget.vue?vue&type=script&setup=true&lang=ts"
export * from "./jivo-chat-widget.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__